module.exports = __webpack_public_path__ + "img/sfondo-arancia.c3525320.png";